import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    forwardRef,
    HostListener,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import {ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {DateTime} from 'luxon';
import { NativeDateAdapter } from '@angular/material/core';

export class CustomDateAdapter extends NativeDateAdapter {

    override getFirstDayOfWeek(): number {
        let user_info: any = sessionStorage.getItem('app_user_info')
        if (user_info) {
            user_info = JSON.parse(user_info)
        }

        if (user_info?.booking_defaults?.calendar_start_day!== undefined) {
            return user_info?.booking_defaults?.calendar_start_day
        }

        if (user_info?.be_booking_defaults?.calendar_start_day !== undefined) {
            return user_info?.be_booking_defaults?.calendar_start_day
        }

        return 0;
    }
}

let cnt = 0
@Component({
    selector: 'sam4-date',
    templateUrl: './date.component.html',
    styleUrls: ['./date.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DateComponent),
            multi: true
        }, {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => DateComponent),
            multi: true
        }],
    standalone: false
})
export class DateComponent implements OnInit, ControlValueAccessor, AfterViewInit {
    private touched = false;
    private isAutoFocused = false;
    public input_focused = false
    public idCnt = 0
    @Input() maxDate!: string
    @Output() focused: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() dateChange: EventEmitter<string> = new EventEmitter<string>();
    @Input() placeholder = '';
    @Input() disabled = false;
    @Input() id?: string;
    @Input() minDate?: string;
    @Input() date?: string;
    @Input() required = false;
    @Input() label?: string;
    @Input() ariaDescribedBy?: string;
    @Input() ariaInvalid?: boolean;
    @ViewChild('input') inputControl?: ElementRef;

    constructor(
        private change: ChangeDetectorRef,
    ) {
        this.idCnt = ++cnt
    }

    @Input()
    set autoFocus(focused: boolean) {
        this.isAutoFocused = focused;
        if (focused && this.inputControl) {
            (this.inputControl?.nativeElement as HTMLInputElement).focus();
        }
    }

    ngAfterViewInit(): void {
        if (this.isAutoFocused) {
            (this.inputControl?.nativeElement as HTMLInputElement).focus();
        }

        if (!this.minDate) {
            const d = DateTime.now();
            this.minDate = d.minus({ days: 2 }).toISODate()!;
        }
    }


    writeValue(date: number | null | string): void {
        if (date) {
            // @todo check

            if (typeof date === 'number') {
                this.date = DateTime.fromMillis(date).toISODate()!;
            } else {
                this.date = date as string;
            }

        } else {
            this.date = '';
        }
        this.change.markForCheck();
    }

    public onTouched = () => {

    }

    public onChange = (value: any) => {
    }

    public eventChange = (evt: any) => {
        this.dateChange.emit(evt.value)
    }

    ngOnInit(): void {

    }

    setInputFocus(focus: boolean) {
        this.input_focused = focus
    }

    getValue() {
        var d = new Date(this.date || '');
        return new Date( d.getTime() - d.getTimezoneOffset() * -60000 )
    }

    focusToInput() {
        setTimeout(() => {
            let el = document.getElementById(this.id || `sam4-date-comp-${this.idCnt}`)
            if (el != null) {
                el.focus()
            }
        }, 500)
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    public isInvalid(): boolean {
        return (this.required && !this.date && this.touched);
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
        this.change.markForCheck();
    }

    validate() {
        return null;
    }

    @HostListener('focusout')
    protected onBlur() {
        if (!this.touched) {
            this.touched = true;
            this.onTouched();
        }
        this.focused.emit(false);
    }

    @HostListener('focusin')
    protected onFocus() {
        this.focused.emit(true);
    }

}
